import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { Skeleton } from '../../../components/ui/skeleton';

/**
 * Bars sized as a share of the column rather than in fixed pixels.
 *
 * The fixed widths were picked against desktop columns and were all wider than
 * the mobile ones — w-28 (112px) in a 76px cell, w-32 (128px) in a 107px cell —
 * so on a phone every bar filled its cell edge to edge and the row read as one
 * unbroken grey band. Shares leave the same gutter at any width.
 */
function RecordRowSkeleton({ isMobile }: any) {
    return (
        <TableRow sx={{ height: 60, '& > *': { py: 0.5 } }}>
            <TableCell padding='checkbox'>
                <Checkbox size='small' disabled />
            </TableCell>
            <TableCell>
                <Skeleton className='h-4 w-1/2' />
            </TableCell>
            <TableCell align='left'>
                <Skeleton className='h-6 w-4/5 rounded-full' />
            </TableCell>
            <TableCell align='left'>
                <Skeleton className='h-4 w-4/5' />
            </TableCell>
            <TableCell align='left'>
                <Skeleton className='h-4 w-3/4' />
            </TableCell>
            {!isMobile && (
                <>
                    <TableCell align='left'>
                        <Skeleton className='h-4 w-1/2' />
                    </TableCell>
                    <TableCell align='left'>
                        <Skeleton className='h-4 w-3/5' />
                    </TableCell>
                    <TableCell align='left'>
                        <Skeleton className='h-4 w-2/3' />
                    </TableCell>
                </>
            )}
            <TableCell align='center'>
                <Skeleton className='h-8 w-8 max-w-full rounded-full' />
            </TableCell>
        </TableRow>
    );
}

export default RecordRowSkeleton;
